import React, { useCallback } from 'react';
import Icon from 'flow/components/ui-components/Icon';
import TicketAvatar from 'flow/components/tickets/TicketAvatar';
import { MenuItem } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';

import useAssigneeLabel, { AssigneeKey } from './useAssigneeLabel';

interface Props {
    extensionKey: AssigneeKey;
    onSelect: (key: AssigneeKey) => void;
}

const AssigneePickerItem = ({ extensionKey, onSelect }: Props) => {
    const label = useAssigneeLabel(extensionKey);

    const onClick = useCallback(() => {
        onSelect(extensionKey);
    }, [onSelect, extensionKey]);

    return (
        <MenuItem>
            {({ focus }) => (
                <button
                    type="button"
                    onClick={onClick}
                    className={twMerge(
                        'flex w-full items-center gap-2 rounded-sm px-2 py-2 text-start text-sm',
                        focus ? 'bg-gray-200' : '',
                    )}
                >
                    {extensionKey !== 'unassigned' ? (
                        <TicketAvatar
                            extensionKey={extensionKey}
                            size="extraSmall"
                            lazyLoad={true}
                        />
                    ) : (
                        <div className="flex size-5 items-center justify-center">
                            <Icon iconKey="pendingOutlined" />
                        </div>
                    )}
                    <span className="line-clamp-1 break-all">{label}</span>
                </button>
            )}
        </MenuItem>
    );
};

export default React.memo(AssigneePickerItem);
